var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hoc-overlay__addition gray-scroller overflow-auto",style:({height: _vm.componentHeight + 'px'})},[_c(_vm.componentName,{tag:"component",on:{"closedAddition":function($event){return _vm.$emit('closedAddition')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }